exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wz_data_table td{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;max-width:400px!important}.wz_data_table{border-top-right-radius:0;border-top-left-radius:0;height:calc(100% - 68px)}.wz_table_header{background-color:#edf3fb;color:#424242;height:68px}.text-start{overflow-wrap:unset}.bottom-spacing{margin-bottom:150px!important}.row-selected{background-color:#447bbd;color:#fff}", ""]);

// exports
